import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "../components/app/Layout";
import api from "../lib/api";

export default function WineriesList() {
    const [wineries, setWineries] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/wineries").then(({ data }) => setWineries(data)).finally(() => setLoading(false));
    }, []);

    return (
        <Layout>
            <section className="px-6 md:px-12 lg:px-16 pt-20 md:pt-28 pb-16" data-testid="wineries-header">
                <p className="overline">The Houses</p>
                <h1 className="font-display text-5xl md:text-7xl mt-4 leading-[0.95]">All Wineries</h1>
                <p className="text-base md:text-lg text-[#A1A1AA] mt-6 max-w-xl leading-relaxed">
                    Verified Argentine producers, curated by region and prestige.
                </p>
            </section>

            <section className="px-6 md:px-12 lg:px-16 pb-32" data-testid="wineries-grid">
                {loading ? (
                    <p className="text-[#71717A]">Loading...</p>
                ) : wineries.length === 0 ? (
                    <div className="border border-[#27272A] p-16 text-center">
                        <p className="font-display text-3xl text-[#A1A1AA]">Curating Argentina&apos;s finest...</p>
                    </div>
                ) : (
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12">
                        {wineries.map((w) => (
                            <Link key={w.id} to={`/winery/${w.slug}`} className="group block mkt-card-lift" data-testid={`winery-card-${w.slug}`}>
                                <div className="aspect-[4/5] overflow-hidden bg-[#0A0A0A]">
                                    <img
                                        src={w.banner_url || w.logo_url || "https://images.unsplash.com/photo-1767969217452-3cc1eb722703?crop=entropy&cs=srgb&fm=jpg&w=900&q=80"}
                                        alt={w.name}
                                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                                        loading="lazy"
                                    />
                                </div>
                                <div className="mt-6">
                                    <p className="overline">{w.region}</p>
                                    <h2 className="font-display text-3xl mt-2 group-hover:text-[#C9A961] transition-colors duration-500">{w.name}</h2>
                                    {w.established_year && <p className="text-sm text-[#71717A] mt-1">Est. {w.established_year}</p>}
                                </div>
                            </Link>
                        ))}
                    </div>
                )}
            </section>
        </Layout>
    );
}
